/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timezone_Utc3Inputs */

const he_timezone_utc3 = /** @type {(inputs: Timezone_Utc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UTC`)
};

const en_timezone_utc3 = /** @type {(inputs: Timezone_Utc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UTC`)
};

/**
* | output |
* | --- |
* | "UTC" |
*
* @param {Timezone_Utc3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const timezone_utc3 = /** @type {((inputs?: Timezone_Utc3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timezone_Utc3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_timezone_utc3(inputs)
	return en_timezone_utc3(inputs)
});
export { timezone_utc3 as "timezone_UTC" }